// frontend/src/api/taskAPI.js
import axiosInstance from './axiosConfig';

const taskAPI = {
  // List tasks (server-side role-scoped)
  getTasks: async ({ status, priority, due } = {}) => {
    const params = {};
    if (status)   params.status   = status;
    if (priority) params.priority = priority;
    if (due)      params.due      = due;
    const res = await axiosInstance.get('/tasks', { params });
    return res.data;
  },

  getTaskStats: async () => {
    const res = await axiosInstance.get('/tasks/stats');
    return res.data;
  },

  getTask: async (id) => {
    const res = await axiosInstance.get(`/tasks/${id}`);
    return res.data;
  },

  createTask: async (data) => {
    const res = await axiosInstance.post('/tasks', data);
    return res.data;
  },

  updateTask: async (id, data) => {
    const res = await axiosInstance.put(`/tasks/${id}`, data);
    return res.data;
  },

  deleteTask: async (id) => {
    const res = await axiosInstance.delete(`/tasks/${id}`);
    return res.data;
  },

  // Trigger reminder notifications for tasks due today / overdue.
  // Cheap to call repeatedly — backend gates with last_reminder_at.
  dispatchReminders: async () => {
    const res = await axiosInstance.post('/tasks/dispatch-reminders');
    return res.data;
  }
};

export default taskAPI;
